const TAG_DEFINE = {
    GENERAL: {
        ITEM: {
            CHECK_VOUCHER: {
                voucher_code: "Mã serial",
                status_explain: "Trạng thái",
                action: "Thao tác"
            },
            USERS: {
                title: "Danh sách người dùng",
                email: "Email",
                status: "Status",
                first_name: "First name",
                last_name: "Last name",
                status_explain: "Status",
                roles: "Role",
                created_at: "Created Date",
                action: "Action"
            },
            CUSTOMERS: {
                title: "Danh sách người dùng",
                email: "Email",
                status: "Status",
                first_name: "First name",
                last_name: "Last name",
                status_explain: "Status",
                roles: "Role",
                phone_number: "Phone number",
                account_manager: "Account manager",
                referral_label: "Referral",
                created_at: "Created Date",
                action: "Action"
            },
            TICKETS: {
                title: "Title",
                code: "Code",
                type: "Type",
                owner: "Owner",
                assignee: "Assignee",
                status: "Status",
                status_explain: "Status",
                comments: "Comment",
                created_at: "Created At",
                updated_at: "Updated At",
                action: "Action"
            },
            SUBSCRIPTION_PACKAGES: {
                title: "Danh sách người dùng",
                package_type: "Partner",
                type: "Type",
                period_type: "Period",
                discount: "Discount",
                price: "Price",
                product_type: "Product",
                created_date: "Created Date",
            },
            SUBSCRIPTION_CUSTOMERS: {
                title: "Danh sách người dùng",
                customer: "Customer",
                package_type: "Package Type",
                package_subscription_type: "Package Subscription Type",
                package_period_type: "Package Period Type",
                valid_time: "Valid Time",
                order: "Order",
                created_date: "Created Date",
                product_type: "Product",
                action: "Action"
            },
            SUBSCRIPTION_TRANSACTIONS: {
                title: "Danh sách người dùng",
                id: "Id",
                code: "Code",
                email: "Customer",
                type: "Type",
                subscription_type: "Subscription Type",
                status_explain: "Status",
                discount_code: "Discount Code",
                price: "Price",
                discount: "Discount Value",
                total_amount: "Total Price",
                month: "Month",
                detail: "Detail",
                lead_type: "Lead Type",
                state: "State",
                county: "County",
                subscribe_date: "Subscribe Date",
                owner: "User"
            },
            SUBSCRIPTION_CANCELATION_FEEDBACK: {
                title: "Danh sách người dùng",
                id: "Id",
                email: "Email",
                point: "Point",
                reason: "Reason",
                experience: "Experience",
                feedback: "Feedback",
                created_date: "Created Date",
                action: "Action"
            },
            EXCLUSIVE_CONTENT_POST: {
                id: "Id",
                thumbnail: "Thumbnail",
                video_url: "Video Url",
                title: "Title",
                description: "Description",
                footer_icon: "Footer Icon",
                footer_hot: "Footer Hot",
                footer_description: "Footer Description",
                status: "Status",
                action: "Action"
            },
            EXCLUSIVE_CONTENT_LAYOUT: {
                id: "Id",
                title: "Title",
                items: "Items",
                groups: "Groups",
                action: "Action"
            },
            SUBSCRIPTION_GENERAL_PACKAGE: {
                title: "Danh sách người dùng",
                type: "Type",
                period_type: "Period Type",
                package_type: "Package Type",
                price: "Price",
                action: "Action"
            },
            SUBSCRIPTION_GEO_DATA: {
                title: "Danh sách người dùng",
                state: "State",
                county: "County",
                city: "City",
                metro: "Metro",
                status: "Status",
                action: "Action"
            },
            SUBSCRIPTION_CUSTOM_PACKAGE: {
                title: "Danh sách người dùng",
                state: "State",
                city: "City",
                county: "County",
                metro: "Metro",
                type: "Type",
                period_type: "Period type",
                package_type: "Package type",
                price: "Price",
                status: "Status",
                action: "Action"
            },
            SUBSCRIPTION_CUSTOMER_RECURRING: {
                title: "Danh sách người dùng",
                email: "Email",
                recurring_date: "Recurring Date",
                price: "Price",
                status: "Status",
                action: "Action"
            },
            SUBSCRIPTION_CUSTOMER_RECURRING_UPDATE_PACKAGES: {
                package: "Package",
                state: "State",
                item: "Item",
                price: "Price",
                code: "Code",
                type: "Type",
                action: "Action",
            },
            SUBSCRIPTION_CUSTOMER_RECURRING_UPDATE_HISTORY: {
                actor: "Actor",
                time: "Time",
                action: "Action",
            },
            CUSTOMER_TEAM_POINT: {
                email: "Customer",
                total_point: "Total Point",
                total_trans: "Total Transaction",
                team_point: "Owned Point",
                team_trans: "Owned Transaction",
                team_point_level_1: "LV1 Ref Point",
                team_trans_level_1: "LV1 Ref Transaction",
                team_point_level_2: "LV2 Ref Point",
                team_trans_level_2: "LV2 Ref Transaction",
                team_point_level_3: "LV3 Ref Point",
                team_trans_level_3: "LV3 Ref Transaction",
                team_point_level_4: "LV4 Ref Point",
                team_trans_level_4: "LV4 Ref Transaction",
                total_commission: "Total Commission",
                team_commission: "Owned Commission",
                team_commission_level_1: "LV1 Ref Commission",
                team_commission_level_2: "LV2 Ref Commission",
                team_commission_level_3: "LV3 Ref Commission",
                team_commission_level_4: "LV4 Ref Commission",
                action: "Action"
            },
            COMPANY: {
                title: "Danh sách người dùng",
                name: "Name",
                owner: "Owner",
                status: "Status",
                action: "Action"
            },
        }
    },
    ACTION: {
        info: "Info 1111",
        export: "Export file",
        import: "Import file",
        create: "Create",
        update: "Update",
        filter: "Filter",
        show: "Show",
        remove: "Remove",
        action: "Action",
        exit: "Exit",
        close: 'Close',
        lock: "Lock",
        unlock: "Unlock",
        refreshData: "Refresh data",
        back: "Bạck",
        backIndex: "Back home",
        statusHide: "Hide",
        statusShow: "Show",
        uploadImage: "Upload Image",
        collapse: "Collapse",
        detail: "Detail",
        noData: "No Data",
        cancel: "Cancel",
        confirm: "Confirm",
        edit: 'Edit',
        add: 'Add',
        addMulti: 'Add Multiple',
        save: 'Save',
        send: 'Send',
        use: 'Use',
        resendEmail: 'Resend Email',
        approve: 'Approve',
        unApprove: 'Unapprove',
        translate: 'Translate',
        unlink: 'Unlink',
        unActive: "Unactive",
        search: "Search"
    },
    NOTIFICATION: {
        title: "Thông báo",
        building: "Tính năng đang được phát triển",
        notInternet: "Kết nối bị lỗi, máy chủ không phản hồi!",
        createSuccess: "Thêm dữ liệu thành công",
        updateSuccess: "Cập nhật dữ liệu thành công",
        removeSuccess: "Xoá dữ liệu thành công",
        checkSuccess: "Kiểm tra thành công",
        uploadSuccess: "Tải dữ liệu thành công",
        resendMailSuccess: "Gởi email thành công",
        changePasswordSuccess: "Đổi mật khẩu thành công",
        assigneeSuccess: "Yêu cầu đã được chuyển",
        cancelTicketSuccess: "Đã huỷ yêu cầu",
        sureRemove: "Bạn chắc chắn muốn xóa ?",
        sureDeActive: "Bạn muốn vô hiệu tài khoản ?",
        sureUse: "Bạn chắc chắn muốn sử dụng ?",
        sureLogout: "Bạn chắc chắn muốn thoát?",
        changePassword: "Bạn chắc chắn muốn đổi mật khẩu?",
        confirmExit: 'Bạn có chắc chắn muốn thoát?',
        confirmBack: 'Bạn có chắc chắn muốn quay về?',
        downloadSuccess: 'Tải về file thành công.',
        youCantAccessThisPage: 'Bạn không thể vào trang này!',
        maxFileSize: 'Kích thước file tối đa',
    },
    PAGINATE: {
        showLine: "Items per page",
        first: "First page",
        last: "Last page",
        previous: "Previous",
        next: "Next",
        of: 'of',
        items: 'items',
        jumpTo: 'Go to',
        itemsPerPage: 'Items / page',
        page: 'page',
    },
    VALIDATION: {
        dropImage: "Drag and drop image",
        email: "Please correct email",
        password:
            "Password includes lowercase characters, uppercase characters, numbers, special characters and more than 6 characters",
        image: "File must be image",
        required: "Data cannot be empty",
        requiredImage: "Image cannot be empty",
        string: "Data must be text",
        number: "Data must be number",
        priceRequired: "Please input price",
        invalidDate: "Invalid date",
        salePriceLessThenPrice: "Giá giảm phải thấp hơn giá gốc",
        sureUse: "Bạn chắc chắn muốn sử dụng ?",
        image1pic: "Vui lòng chọn 1 tấm hình",
        maxImage: "Tối đa 5 tấm hình",
        passwordRequired: "Mật khẩu không được rỗng",
        currentPasswordRequired: "Mật khẩu cũ không được rỗng",
        newPasswordRequired: "Mật khẩu mới không được rỗng",
        confirmPasswordRequired: "Mật khẩu xác nhận không được rỗng",
        usernameRequired: "Tài khoản không được rỗng",
        usernameOrPasswordNotMatch: "Tài khoản hoặc mật khẩu không đúng",
        userLocked: "Sai thông tin đăng nhập hoặc tài khoản bị khoá",
        connectFail: "Kết nối bị lỗi, máy chủ không phản hồi!",
        voucherInvalid: "Mã số voucher không hợp lệ",
        userNameExists: "Tài khoản đã tồn tại!",
        uploadFail: "Tải tập tin không thành công",
        percent: "Không được quá 100%",
        minOrderValue: "Dữ liệu phải nhỏ hơn đơn hàng tối đa",
        maxPhone: "Không được quá 12 ký tự",
        minPhone: "Dữ liệu phải từ 8 ký tự trở lên",
        minpassword: "Dữ liệu phải từ 6 ký tự trở lên",
        quantity: "Số lượng ít nhất là 1",
        LessThenZero: "Dữ liệu phải lớn hơn 0",
        MinValue: "Dữ liệu phải lớn hơn",
        isPhone: "Vui lòng nhập đúng số điện thoại",
        isSpecialString: "Vui lòng không nhập ký tự đặc biệt",
        isUrl: "Vui lòng nhập đúng đường dẫn",
        recaptcha: "Vui lòng xác nhận trước khi đăng nhập",
        comparePassword: "Mật khẩu xác nhận không trùng khớp",
        nameRequired: "Tên không được rỗng",
        codeRequired: "Code không được rỗng",
        starRequired: "Hạng không được để trống",
        checkForm: "Vui lòng kiểm tra lại dữ liệu",
        unknowError: 'Lỗi không xác định',
        nullData: "No Data",
        hotelsUnActiveConfirm: "Huỷ kích họat khách sạn sẽ ần thông tin của khách sạn này trên các sản phẩm đang có. Bạn có chắn muốn huỷ kích hoạt?",
        statusCode: {
            code: {
                200: "Upload successful",
                201: "Create successful",
                204: "Update data successful",
                203: "Delete data successful",
                400: "Không cập không hiệu lực",
                401: "Please login to the page!",
                403: "You do not have permission to access this site!.",
                404: "Page Not Found",
                405: 'Không hỗ trợ',
                406: 'Kill Session Success',
                1: "%s is reuqired",
                2: "%s is number",
                3: "%s quá giới hạn",
                4: "Không được quá %s ký tự",
                5: "Không được quá %s file",
                6: "Chưa có dữ liệu",
                7: "Bạn chắn chắn muốn xoá %s",
                8: 'Giá trị không được lớn hơn "%s"',
                9: "Hình ảnh tối đa là %s tấm hình",
                10: "Vui lòng nhập %s",
                11: "Vui lòng chọn %s",
                12: "Vui lòng chọn ít nhất %s tấm hình",
                13: "Vui lòng chọn ít nhất %s",
                14: "Bạn chắn chắn muốn cập nhật %s",
                15: 'Value minimum is "%s"',
                1208: "Tài khoản hoặc mật khẩu không hợp lệ",
                1403: "Tài khoản hoặc mật khẩu không hợp lệ",
                1406: "Số điện thoại không hợp lệ",
                1409: "Vui lòng chọn trạm",
                1404: "Tài khoản hoặc email đã tồn tại!",
                1414: "Thông tin đăng nhập không đúng !",
                1210: "Thông tin đăng nhập không đúng !",
                1417: "Bạn không thể cập nhật nhân viên này!",
                1418: "Mã nhân viên không được trùng",
                1555: "Vui lòng nhập lý do hủy phiếu!",
                1563: "Nhân viên được giao không có quyền thực hiện phiếu yêu cầu",
                8001: "Tài khoàn hoặc mật khẩu của bạn không đúng. Vui lòng thử lại",
                8002: "IP đã bị chặn truy cập vào đường dẫn trên. Vui lòng quay lại sau",
                8003: "Tài khoản đã bị tạm khóa trong vòng 15'. Vui lòng quay lại sau",
                8004: "Bạn không có quyền để hủy ticket này",

                // Promotion: 10000
                10001: "Không thể tìm được chương trình",
                GROUP_NOT_FOUND: 'Không thể tìm được chương trình',
                10002: "Cơ sở không tồn tại",
                GROUP_PROPERTY_IDS_NOT_EXIST: 'Cơ sở không tồn tại',
                10003: "Sản phẩm không tồn tại",
                GROUP_PRODUCT_IDS_NOT_EXIST: 'Sản phẩm không tồn tại',
                10004: "Chương trình đang được bán",
                GROUP_IS_RUNNING: 'Chương trình đang được bán',
                10005: "Chương trình đã kết thúc",
                GROUP_WAS_ENDED: 'Chương trình đã kết thúc',
                10006: "Ngày giờ mở bán không được nhỏ hơn ngày giờ hiện tại",
                START_DATE_LESS_THAN_NOW: 'Ngày bắt đầu không được nhỏ hơn ngày giờ hiện tại',
                10007: "Ngày bắt đầu/Ngày mở bán không được lớn hơn ngày kết thúc/Ngày ngừng bán",
                START_DATE_LARGER_THAN_END_DATE: 'Ngày bắt đầu không được lớn hơn ngày kết thúc',
                10008: "Ngày ngừng bán không được lớn hơn ngày kết thúc",
                SALE_START_DATE_LARGER_THAN_SALE_END_DATE: 'Ngày ngừng bán không được lớn hơn ngày kết thúc',
                10101: "Ngày bắt đầu không được nhỏ hơn ngày hiện tại",
                SALE_END_DATE_LARGER_THAN_END_DATE: 'Ngày bắt đầu không được nhỏ hơn ngày hiện tại',
                DATE_LESS_THAN_NOW: 'Ngày giờ không được nhỏ hơn ngay giờ hiện tại',
                MIN_PRICE_LARGER_THAN_MAX_PRICE: 'Giá thấp nhất không được lớn hơn giá cao nhất',
                // Voucher: 11000
                11001: "Mã voucher không hợp lệ",
                SERIAL_NUMBER_INVALID: 'Mã voucher không hợp lệ',
                11002: "Không tìm thấy voucher",
                VOUCHER_NOT_FOUND: 'Không tìm thấy voucher',
                11003: "Voucher đã được sử dụng",
                VOUCHER_USED: 'Voucher đã được sử dụng',
                11004: "Voucher đã bị khoá",
                VOUCHER_LOCKED: 'Voucher đã bị khoá',
                11005: "Voucher đã hết số lần sử dụng",
                VOUCHER_USED_UP: 'Voucher đã hết số lần sử dụng',
                11006: "Chương trình tạm dừng",
                GROUP_UNAVAILABLE: 'Chương trình tạm dừng',
                11007: "Voucher đã hết hạn",
                VOUCHER_WAS_EXPIRED: 'Voucher đã hết hạn',
                11008: "Chương trình chưa bắt đầu",
                GROUP_NOT_STARTED_YET: 'Chương trình chưa bắt đầu',
                11009: "Voucher chưa đến ngày sử dụng",
                VOUCHER_NOT_STARTED_YET: 'Voucher chưa đến ngày sử dụng',
                11010: "Voucher không thể sử dụng tại cơ sở này",
                VOUCHER_PROPERTY_ERROR: 'Voucher không thể sử dụng tại cơ sở này',
                // User: 12000
                12001: "Không tìm thấy tài khoản hoặc tài khoản đã bị khoá",
                12002: "Tài khoản đã tồn tại",
                ID_USER_EXISTED: 'Tài khoản đã tồn tại',
                12003: "Cơ sở không tồn tại hoặc đã bị xoá",
                12004: "Quyền hạn chưa được cập nhật hoặc không tồn tại",
                12005: "Tài khoản không thể xoá",
                12006: "Tài khoản sẽ bị khoá nếu đăng nhập sai nhiều lần",
                ID_USER_LOCK_WARNING: "Tài khoản sẽ bị khoá nếu đăng nhập sai nhiều lần",
                12007: "Email chưa được xác nhận",
                12008: "Tài khoản đã bị khoá",
                ID_USER_LOCKED: 'Tài khoản đã bị khoá',
                12010: "Mã xác nhận sai",
                ID_WRONG_OLD_PASSWORD: "Mật khẩu cũ không chính xác",
                12011: "Mật khẩu cũ không chính xác",
                12012: "Email đã tồn tại",
                // Cart: 13000
                13001: "Chương trình không tồn tại",
                13002: "Voucher không đủ",
                13003: "Không tìm thấy giỏ hàng",
                13004: "Cart item not found",
                //ImportData: 14000
                14001: "Nhập dữ liệu thất bại",
                FAILED_TO_IMPORT_DATA: 'Nhập dữ liệu thất bại',
                FILE_NOT_FOUND: 'Không tìm thấy file',
                NOT_EXCEL_FORMAT: 'Không đúng định dạng excel',
                // UploadFile: 15000 (Storage)
                15001: "Tải dữ liệu thất bại",
                15002: "Không tìm thấy dữ liệu",
                15003: "Dữ liệu không được chấp nhận, Vui lòng chọn lại",
                15004: "Dung lượng dữ liệu bị giới hạn",
                // Banner: 16000 (Storage)
                16001: "Không tìm thấy hình ảnh",
                // Order: 17000 (Booking)
                17001: "Không tìm thấy đơn hàng",
                17002: "Đặt hàng thất bại",
                17003: "Đơn hàng đã được thanh toán",
                17004: "Không đủ voucher",
                // Property: 18000
                18001: "Không tìm thấy cơ sở",
                PROPERTY_NOT_FOUND: 'Không tìm thấy cơ sở',
                PROPERTY_USED: 'Cơ sở đang được sử dụng',
                // Product: 19000
                19001: "Không tìm thấy sản phẩm",
                PRODUCT_NOT_FOUND: 'Không tìm thấy sản phẩm',
                PRODUCT_USED: 'Sản phẩm đang được sử dụng',
                // Customer: 20000
                20001: "Không tìm thấy khách hàng",

                21001: "Chỉ được xem trong vòng 90 ngày",
                21002: "Ngày bắt đầu không được lớn hơn ngày kết thúc hoặc ngày hiện tại",
                //Role
                22001: "Vai trò không tồn tại",
                22002: "Vai trò đã tồn tại",
                22003: "Vai trò đã được sử dụng",
                UNDEFINED_ERROR: 'Lỗi không xác định',
                INVALID_CAPTCHA: 'Sai mã xác thực',
                PAGE_NOT_FOUND: "Không tìm thấy trang",
                CATEGORY_NOT_FOUND: "Không tìm thấy danh mục",
                CATEGORY_EXISTED: "Danh mục đã tồn tại",
                CATEGORY_USED: "Danh mục đã sử dụng",
                CATEGORY_IDS_NOT_EXIST: "Một số danh mục đã tồn tại",
                TAG_NOT_FOUND: "Không tìm thấy thẻ",
                TAG_EXISTED: "Thẻ tồn tại",
                TAG_USED: "Thẻ đã dùng",
                BANNER_NOT_FOUND: "Không tìm thấy banner",
                FILE_UPLOAD_FAILED: "Tải lên bị lỗi",
                FILE_TYPE_NOT_ACCEPTED: "Loại file không hỗ trợ",
                FILE_LENGTH_OVER_LIMIT: "File quá giới hạn kích thước",
                ZERO_FILE_LENGTH: "File rỗng",
                DIRECTORY_NOT_ALLOW: 'Thư mục không được phép thao tác',
            }
        }
    },
    ACTION_OPTIONS: {
        CREATE: 'CREATE',
        CLONE: 'CLONE',
        UPDATE: 'UPDATE',
        TRANSLATE: 'TRANSLATE',
    }
};
export default TAG_DEFINE;
